import { tv, type VariantProps } from "tailwind-variants";

export const sliderVariants = tv(
  {
    slots: {
      base: ["w-full", "py-4"],
      container: ["container-fluid"],
      slider: [
        "w-full !h-auto",
        "[&_.swiper-pagination]:absolute [&_.swiper-pagination]:z-10 [&_.swiper-pagination]:flex [&_.swiper-pagination]:gap-4",
        "[&_.swiper-pagination]:!h-4.5 [&_.swiper-pagination]:!w-auto [&_.swiper-pagination]:!bottom-6 [&_.swiper-pagination]:!left-8",
        "[&_.swiper-pagination]:md:!bottom-12 [&_.swiper-pagination]:md:!left-12",
        "[&_.swiper-pagination-bullet]:inline-block [&_.swiper-pagination-bullet]:w-4 [&_.swiper-pagination-bullet]:h-4",
        "[&_.swiper-pagination-bullet]:rounded-full [&_.swiper-pagination-bullet]:border-2 [&_.swiper-pagination-bullet]:border-transparent",
        "[&_.swiper-pagination-bullet]:bg-surface-static-white/70 [&_.swiper-pagination-bullet]:md:bg-text-neutral-softer",
        "[&_.swiper-pagination-bullet-active]:bg-surface-static-white [&_.swiper-pagination-bullet-active]:border-static-black",
        "[&_.swiper-pagination-bullet-active]:md:bg-neutral-default [&_.swiper-pagination-bullet-active]:md:border-surface-neutral-softer",
        "[&_.swiper-pagination-bullet-active]:outline-1",
        "[&_.swiper-pagination-bullet-active]:outline-surface-static-white [&_.swiper-pagination-bullet-active]:md:outline-border-static-black",
        "[&_.swiper-pagination-bullet]:transition-colors [&_.swiper-pagination-bullet]:cursor-pointer",
      ],
      slide: [],
    },
  },
  { twMerge: false },
);

export const slideCardVariants = tv({
  slots: {
    base: ["w-full h-full", "relative grid grid-cols-1 gap-6 md:grid-cols-2"],
    card: [
      "relative",
      "h-full",
      "aspect-auto min-h-130 pb-18 xl:aspect-square xl:min-h-auto",
      "overflow-hidden",
      "rounded-3xl",
      "border border-border-neutral-default",
      "bg-surface-static-black/75 md:bg-surface-neutral-softer",
    ],
    caption: ["w-full h-full", "relative z-10", "p-8 lg:p-12", "flex flex-col gap-6"],
    captionContent: ["flex flex-col gap-4"],
    title: [
      "text-text-static-white-soft md:text-text-neutral-soft",
      "max-w-lg",
      "[&_b]:!text-white [&_b]:!font-regular [&_b]:md:!text-text-neutral-default",
    ],
    legend: ["text-white md:text-text-neutral-default", "max-w-lg", "font-medium"],
    description: [
      "text-text-static-white-soft md:text-text-neutral-soft",
      "max-w-lg",
      "font-medium",
    ],
    buttons: [],
    image: ["w-full h-full object-cover"],
    mediaWrapper: ["w-full", "h-full"],
    media: ["w-full", "h-full", "object-cover"],
  },
});

export type SliderVariantProps = VariantProps<typeof sliderVariants>;

export type SliderReturnVariantProps = ReturnType<typeof sliderVariants>;

export type SlideCardVariantProps = VariantProps<typeof slideCardVariants>;

export type SlideCardReturnVariantProps = ReturnType<typeof slideCardVariants>;
